<template>
  <div class="p-6">
    <div class="mb-6">
      <h1 class="text-2xl font-bold text-gray-900 dark:text-white mb-2">
        Tipos de Componente (V2)
      </h1>
      <p class="text-gray-600 dark:text-gray-400">
        Gestión de tipos de componentes del sistema
      </p>
    </div>

    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
      <div class="p-6 border-b border-gray-200 dark:border-gray-700">
        <div class="flex justify-between items-center">
          <h2 class="text-lg font-semibold text-gray-900 dark:text-white">
            Lista de Tipos de Componente
          </h2>
          <button
            @click="openModal()"
            class="bg-violet-600 hover:bg-violet-700 text-white px-4 py-2 rounded-lg transition-colors duration-200 flex items-center gap-2"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
            </svg>
            Nuevo Tipo
          </button>
        </div>
      </div>

      <div class="p-6">
        <div v-if="loading" class="text-center py-8">
          <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-violet-600 mx-auto"></div>
        </div>

        <div v-else class="overflow-x-auto">
          <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead class="text-xs uppercase bg-gray-100 dark:bg-gray-800 dark:text-gray-300 border-b-2 border-gray-200 dark:border-gray-700">
              <tr>
                <th class="px-4 py-2 font-bold">ID</th>
                <th class="px-4 py-2 font-bold">Nombre</th>
                <th class="px-4 py-2 font-bold">Descripción</th>
                <th class="px-4 py-2 font-bold">Catálogos</th>
                <th class="px-4 py-2 font-bold">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="tipo in tiposComponente"
                :key="tipo.tipoComponenteId"
                class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 even:bg-gray-50 dark:even:bg-gray-700"
              >
                <td class="px-4 py-2 font-medium text-gray-900 dark:text-white">
                  {{ tipo.tipoComponenteId }}
                </td>
                <td class="px-4 py-2 font-medium text-gray-900 dark:text-white">
                  {{ tipo.nombreTipo }}
                </td>
                <td class="px-4 py-2 text-gray-700 dark:text-gray-200">
                  {{ tipo.descripcion || '-' }}
                </td>
                <td class="px-4 py-2 text-gray-700 dark:text-gray-200">
                  <span class="px-2 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300">
                    {{ tipo.catalogos?.length || 0 }} catálogos
                  </span>
                </td>
                <td class="px-4 py-2">
                  <div class="flex gap-2">
                    <button @click="openModal(tipo)" class="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                      </svg>
                    </button>
                    <button @click="eliminar(tipo)" class="text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="tiposComponente.length === 0">
                <td colspan="5" class="px-4 py-8 text-center text-gray-500 dark:text-gray-400">
                  No hay tipos de componente registrados
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div v-if="showModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div class="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-lg w-full">
        <div class="p-6 border-b border-gray-200 dark:border-gray-700">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
            {{ editando ? 'Editar Tipo de Componente' : 'Nuevo Tipo de Componente' }}
          </h3>
        </div>

        <div class="p-6 space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Nombre del Tipo *
            </label>
            <input
              v-model="formData.nombreTipo"
              type="text"
              class="w-full px-3 py-2 rounded border bg-gray-50 dark:bg-gray-900 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-violet-200"
              placeholder="Ej: IMPRESIÓN"
            />
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Descripción
            </label>
            <textarea
              v-model="formData.descripcion"
              rows="3"
              class="w-full px-3 py-2 rounded border bg-gray-50 dark:bg-gray-900 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-violet-200"
              placeholder="Descripción del tipo de componente"
            ></textarea>
          </div>
        </div>

        <div class="p-6 border-t border-gray-200 dark:border-gray-700 flex justify-end gap-2">
          <button
            @click="closeModal"
            class="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition"
          >
            Cancelar
          </button>
          <button
            @click="guardar"
            :disabled="loading"
            class="px-4 py-2 bg-violet-600 hover:bg-violet-700 text-white rounded-lg transition disabled:opacity-50"
          >
            {{ loading ? 'Guardando...' : 'Guardar' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useCatalogosNew } from '../../composables/useCatalogosNew'

const {
  loading,
  tiposComponente,
  fetchTiposComponente,
  createTipoComponente,
  updateTipoComponente,
  deleteTipoComponente
} = useCatalogosNew()

const showModal = ref(false)
const editando = ref(null)
const formData = ref({
  nombreTipo: '',
  descripcion: ''
})

onMounted(async () => {
  await fetchTiposComponente()
})

const openModal = (tipo = null) => {
  if (tipo) {
    editando.value = tipo
    formData.value = {
      nombreTipo: tipo.nombreTipo,
      descripcion: tipo.descripcion || ''
    }
  } else {
    editando.value = null
    formData.value = {
      nombreTipo: '',
      descripcion: ''
    }
  }
  showModal.value = true
}

const closeModal = () => {
  showModal.value = false
  editando.value = null
  formData.value = {
    nombreTipo: '',
    descripcion: ''
  }
}

const guardar = async () => {
  try {
    if (editando.value) {
      await updateTipoComponente(editando.value.tipoComponenteId, formData.value)
    } else {
      await createTipoComponente(formData.value)
    }
    closeModal()
  } catch (error) {
    console.error('Error al guardar:', error)
  }
}

const eliminar = async (tipo) => {
  if (confirm(`¿Está seguro de eliminar el tipo "${tipo.nombreTipo}"?`)) {
    try {
      await deleteTipoComponente(tipo.tipoComponenteId)
    } catch (error) {
      console.error('Error al eliminar:', error)
    }
  }
}
</script>
